import React, { useState, useRef, useEffect } from "react";
import "./TopCollegeStyles.scss";
import ManavRachanaLogo from "../../../images/scholarship-results/manav-rachn.webp";
import SaiULogo from "../../../images/scholarship-results/sai-logo.webp";
import sVyasaLogo from "../../../images/scholarship-results/svyasa-logo.webp";
import UPESLogo from "../../../images/scholarship-results/upes-logo.webp";
import ShardaLogo from "../../../images/scholarship-results/sharda-university-logo.webp";
import PanditLogo from "../../../images/scholarship-results/pandit-deendayal-logo.webp";
import MgrMedicalLogo from "../../../images/scholarship-results/educationalresearch-logo.webp";
import SaveethaLogo from "../../../images/scholarship-results/SaveethaLogo.webp";
import AnnamacharyaLogo from "../../../images/scholarship-results/annamacharya-university-logo.webp";
import AllianceLogo from "../../../images/scholarship-results/alliance-university-logo.webp";
import RamachandraLogo from "../../../images/scholarship-results/sriher-logo.webp";
import KaveriLogo from "../../../images/scholarship-results/kaveri-university.webp";
import adityaLogo from "../../../images/scholarship-results/aditya-university-logo.webp";
import BennettLogo from "../../../images/scholarship-results/BennettLogo.webp";
import ChandigarhLogo from "../../../images/scholarship-results/chandigarh-logo.webp";
import GoenkaLogo from "../../../images/scholarship-results/gd-coenka-logo.webp";
import MallaLogo from "../../../images/scholarship-results/malla-ready-logo.webp";
import { Link } from "react-router-dom";

const slugify = (text: string) =>
  text
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "");

const collegeData = [
  {
    name: "Manav Rachna University",
    location: "Faridabad, Haryana",
    logo: ManavRachanaLogo,
    slug: "mriirs-faridabad-manav-rachna-international-institute-of-research-and-studies-faridabad",
    coords: { x: 32.03, y: 29.84 },
  },
  {
    name: "Sai University",
    location: "Paiyanur, Tamil Nadu",
    logo: SaiULogo,
    slug: "sai-university-chennai",
    coords: { x: (435 / 1098) * 100, y: (980 / 1142) * 100 },
  },
  {
    name: "S-VYASA University",
    location: "Bangalore, Giddenahalli, Karnataka",
    logo: sVyasaLogo,
    slug: "s-vyasa-university-global-city-campus-bengaluru",
    coords: { x: (340 / 1098) * 100, y: (930 / 1142) * 100 },
  },
  // {
  //   name: "UPES University",
  //   location: "Prem Nagar, Uttarakhand",
  //   logo: UPESLogo,
  //   slug: "upes-university-of-petroleum-and-energy-studies",
  //   coords: { x: (400 / 1098) * 100, y: (290 / 1200) * 100 },
  // },
  {
    name: "Sharda",
    location: "Greater Noida, Uttar Pradesh",
    logo: ShardaLogo,
    slug: "sri-sharada-institute-of-indian-management-research-new-delhi",
    coords: { x: (390 / 1098) * 100, y: (390 / 1200) * 100 },
  },
  {
    name: "Pandit Deendayal Energy University",
    location: "Gandhinagar, Raysan, Gujarat",
    logo: PanditLogo,
    slug: "#",
    coords: { x: (150 / 1098) * 100, y: (570 / 1200) * 100 },
  },
  {
    name: "Dr. M.G.R. Medical University",
    location: "Chennai, Tamil Nadu",
    logo: MgrMedicalLogo,
    slug: "dr-mgr-educational-and-research-institute-chennai",
    coords: { x: (420 / 1098) * 100, y: (1010 / 1200) * 100 },
  },
  {
    name: "Saveetha University",
    location: "Chennai, Tamil Nadu",
    logo: SaveethaLogo,
    slug: "simats-saveetha-institute-of-medical-and-technical-sciences-chennai",
    coords: { x: (430 / 1098) * 100, y: (990 / 1200) * 100 },
  },
  {
    name: "Annamacharya University",
    location: "Boyanapalli, Andhra Pradesh",
    logo: AnnamacharyaLogo,
    slug: "annamacharya-institute-of-technology-and-sciences-kadapa",
    coords: { x: (420 / 1098) * 100, y: (920 / 1200) * 100 },
  },
  // {
  //   name: "Alliance University",
  //   location: "Bengaluru, Karnataka",
  //   logo: AllianceLogo,
  //   slug: "alliance-university-bangalore",
  //   coords: { x: (345 / 1098) * 100, y: (1000 / 1200) * 100 },
  // },
  {
    name: "Sri Ramachandra Institute of Higher Education and Research",
    location: "Porur, Chennai, Tamil Nadu",
    logo: RamachandraLogo,
    slug: "sri-ramachandra-institute-of-higher-education-and-research-chennai",
    coords: { x: (450 / 1098) * 100, y: (980 / 1200) * 100 },
  },
  {
    name: "Kaveri University",
    location: "Gowraram, Telangana",
    logo: KaveriLogo,
    slug: "kaveri-university-siddipet",
    coords: { x: (440 / 1098) * 100, y: (800 / 1200) * 100 },
  },
  {
    name: "Aditya University",
    location: "Surampalem, Andhra Pradesh",
    logo: adityaLogo,
    slug: "aditya-university-kakinada",
    coords: { x: (540 / 1098) * 100, y: (820 / 1200) * 100 },
  },
  // {
  //   name: "Bennett University",
  //   location: "Greater Noida, Uttar Pradesh",
  //   logo: BennettLogo,
  //   slug: "bennett-university-greater-noida",
  //   coords: { x: (380 / 1098) * 100, y: (340 / 1142) * 100 },
  // },
  {
    name: "Chandigarh University",
    location: "Chandigarh State, Punjab",
    logo: ChandigarhLogo,
    slug: "chandigarh-university",
    coords: { x: (330 / 1098) * 100, y: (265 / 1142) * 100 },
  },
  {
    name: "GD Goenka University",
    location: "Gurugram, Haryana",
    logo: GoenkaLogo,
    slug: "#",
    coords: { x: (345 / 1098) * 100, y: (340 / 1142) * 100 },
  },
  {
    name: "Malla Reddy University",
    location: "Hyderabad, Telangana",
    logo: MallaLogo,
    slug: "malla-reddy-university-hyderabad",
    coords: { x: (420 / 1098) * 100, y: (790 / 1200) * 100 },
  },
];

const TopCollegesUniversities: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  const handleDotClick = (index: number) => {
    setActiveIndex(index);
    const slug = slugify(collegeData[index].name);
    window.history.pushState(null, "", `#campus-${slug}`);

    cardRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.startsWith("#campus-")) {
      const slug = hash.replace("#campus-", "");
      const index = collegeData.findIndex(
        (college) => slugify(college.name) === slug
      );
      if (index !== -1) {
        setActiveIndex(index);
        setTimeout(() => {
          cardRefs.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);
      }
    }
  }, []);

  return (
    <div className="w-full bg-[#E2F3FF] flex flex-col items-center pt-4 pb-16 mt-1">
      <div className="container flex flex-col">
        <div className="text-center">
          <h2 className="text-[#0C9] text-[36px] max-md:text-[32px] font-bold leading-[50px]">
            Top 100+ Partner Colleges and Universities
          </h2>
          <p className="text-[#173CBA] text-[32px] max-md:text-[24px] font-normal leading-[50px]">
            Associated with College Mentor
          </p>
        </div>

        <div className="flex flex-col max-md:gap-10 lg:flex-row items-center md:mt-6 justify-between xl:mx-20">
          <div className="relative w-[501px] h-[574px] max-md:w-[313px] max-md:h-[347px]">
            <img
              src="/images/india-map.webp"
              alt="India Map"
              className="w-full h-full object-contain"
            />
            {collegeData.map((college, index) =>
              college.coords ? (
                <div
                  key={index}
                  className="absolute"
                  style={{
                    left: `${college.coords.x}%`,
                    top: `${college.coords.y}%`,
                    transform: "translate(-50%, -50%)",
                    zIndex:
                      hoveredIndex === index || activeIndex === index ? 10 : 1,
                  }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <div
                    className={`w-2 h-2 rounded-full transition-all duration-200 cursor-pointer ${
                      index === activeIndex
                        ? "bg-blue hover:bg-blue pulse-blue-dot"
                        : "bg-red hover:bg-red pulse-red-dot"
                    }`}
                    onClick={() => handleDotClick(index)}
                  />

                  {hoveredIndex === index && (
                    <span
                      onClick={() => handleDotClick(index)}
                      className="absolute top-2 left-1/2 -translate-x-1/2 whitespace-nowrap bg-white text-black text-xs px-2 py-1 border border-gray-300 rounded shadow-md z-10 cursor-pointer hover:bg-blue-100"
                    >
                      {college.name}
                    </span>
                  )}
                </div>
              ) : null
            )}
          </div>

          <div className="flex flex-col gap-[15px] h-[574px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 pr-4 max-md:pr-1">
            {collegeData.map((college, index) => (
              <div
                key={index}
                ref={(el) => (cardRefs.current[index] = el)}
                onClick={() => handleDotClick(index)}
                className={`w-[460px] max-md:w-[371px] flex items-center gap-4 border ${
                  index === activeIndex
                    ? "border-blue border-2 shadow-xl"
                    : "border-transparent border-2"
                } bg-white shadow-md rounded-lg p-[10px] cursor-pointer`}
              >
                {college.slug && college.slug !== "#" ? (
                  <Link
                    to={`/college-details/${college.slug}`}
                    className="flex items-center gap-4"
                  >
                    <div className="w-[140px] h-[80px] overflow-hidden flex-shrink-0 border-[0.5px] border-[#A3A2AC] bg-white flex items-center justify-center p-1">
                      <img
                        src={college.logo}
                        alt={college.name}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <div>
                      <h3 className="text-[#383838] text-[18px] font-bold leading-[28px]">
                        {college.name}
                      </h3>
                      <p className="text-[#383838] text-[18px] font-normal leading-[28px]">
                        {college.location}
                      </p>
                    </div>
                  </Link>
                ) : (
                  <div className="flex items-center gap-4 pointer-events-none">
                    <div className="w-[140px] h-[80px] overflow-hidden flex-shrink-0 border-[0.5px] border-[#A3A2AC] bg-white flex items-center justify-center p-1">
                      <img
                        src={college.logo}
                        alt={college.name}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <div>
                      <h3 className="text-[#383838] text-[18px] font-bold leading-[28px]">
                        {college.name}
                      </h3>
                      <p className="text-[#383838] text-[18px] font-normal leading-[28px]">
                        {college.location}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopCollegesUniversities;
